export const COUNT_BYS = ['keyResults', 'objectives'] as const;

export const OVERVIEW_VIEWS = ['list', 'card', 'detail', 'relationships'] as const;

export const TRACKING_STATUSES = ['offTrack', 'atRisk', 'onTrack', 'achieved'] as const;

export const AVAILABLE_OVERVIEW_VIEWS = ['list'] as const;

export const EMOJI_ICONS = [
  { emoji: '🎯', id: 'target' },
  { emoji: '🏆', id: 'trophy' },
  { emoji: '🥇', id: 'goldMedal' },
  { emoji: '🥈', id: 'silverMedal' },
  { emoji: '🥉', id: 'bronzeMedal' },
  { emoji: '🚀', id: 'rocket' },
  { emoji: '📈', id: 'chartIncreasing' },
  { emoji: '📉', id: 'chartDecreasing' },
  { emoji: '📊', id: 'barChart' },
  { emoji: '💡', id: 'idea' },
  { emoji: '⚡', id: 'lightning' },
  { emoji: '🔥', id: 'fire' },
  { emoji: '🌟', id: 'star' },
  { emoji: '✨', id: 'sparkles' },
  { emoji: '🧭', id: 'compass' },
  { emoji: '🏛️', id: 'institution' },
  { emoji: '🛠️', id: 'tools' },
  { emoji: '⚙️', id: 'gear' },
  { emoji: '🔧', id: 'wrench' },
  { emoji: '🔒', id: 'lock' },
  { emoji: '🔑', id: 'key' },
  { emoji: '🛡️', id: 'shield' },
  { emoji: '💰', id: 'money' },
  { emoji: '💵', id: 'dollar' },
  { emoji: '💳', id: 'card' },
  { emoji: '📦', id: 'package' },
  { emoji: '🚚', id: 'truck' },
  { emoji: '🌐', id: 'globe' },
  { emoji: '🗺️', id: 'map' },
  { emoji: '📅', id: 'calendar' },
  { emoji: '⏰', id: 'clock' },
  { emoji: '✅', id: 'check' },
  { emoji: '📝', id: 'notes' },
  { emoji: '📄', id: 'document' },
  { emoji: '📋', id: 'clipboard' },
  { emoji: '🔍', id: 'search' },
  { emoji: '🧩', id: 'puzzle' },
  { emoji: '🤝', id: 'handshake' },
  { emoji: '👥', id: 'people' },
  { emoji: '🧑‍💻', id: 'developer' },
  { emoji: '🎓', id: 'graduation' },
  { emoji: '🏗️', id: 'construction' },
  { emoji: '🏢', id: 'building' },
  { emoji: '🏠', id: 'home' },
  { emoji: '🌍', id: 'earthEuropeAfrica' },
  { emoji: '🛰️', id: 'satellite' },
  { emoji: '📱', id: 'phone' },
  { emoji: '💻', id: 'laptop' },
  { emoji: '🖥️', id: 'desktop' },
  { emoji: '☁️', id: 'cloud' },
  { emoji: '🔐', id: 'security' },
  { emoji: '📢', id: 'announcement' },
  { emoji: '📣', id: 'megaphone' },
  { emoji: '🎉', id: 'celebration' },
  { emoji: '🎊', id: 'confetti' },
  { emoji: '🏁', id: 'finish' },
  { emoji: '🚩', id: 'flag' },
  { emoji: '🌱', id: 'seedling' },
  { emoji: '🌳', id: 'tree' },
  { emoji: '♻️', id: 'recycle' },
  { emoji: '❤️', id: 'heart' },
  { emoji: '🙌', id: 'celebrate' },
  { emoji: '💪', id: 'strength' },
  { emoji: '🧠', id: 'brain' },
  { emoji: '🎨', id: 'design' },
  { emoji: '🎬', id: 'clapperBoard' },
  { emoji: '📷', id: 'camera' },
  { emoji: '🎵', id: 'music' },
  { emoji: '🛒', id: 'shopping' },
  { emoji: '🏪', id: 'store' },
  { emoji: '✈️', id: 'travel' },
  { emoji: '🚢', id: 'ship' },
  { emoji: '🚦', id: 'status' },
  { emoji: '🔔', id: 'notification' },
  { emoji: '📌', id: 'pin' },
  { emoji: '⭐', id: 'starFilled' },
  { emoji: '🧗', id: 'climbing' },
  { emoji: '🐢', id: 'turtle' },
  { emoji: '🐇', id: 'rabbit' },
  { emoji: '🌎', id: 'earthAmericas' },
  { emoji: '🧮', id: 'abacus' },
  { emoji: '📐', id: 'ruler' },
] as const;
